<template>
  <div>
    <a-col :span="24">
      <!-- <h3>{{ $t('i18n_route_XD2_1_1') }}</h3> -->
      <a-spin :spinning="isLoading">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          :rules="rules"
        >
          <a-row>
            <a-col span="24">
              <a-form-model-item
                :label="$t('i18n_order_create_time')"
                prop="createdAt"
              >
                <a-date-picker
                  v-model="form.createdAt"
                  :show-time="{ hideDisabledOptions: true }"
                  format="YYYY-MM-DD HH:mm"
                  :placeholder="
                    $t('i18n_rule_required_select', {
                      field: $t('i18n_order_create_time')
                    })
                  "
                  :locale="datePickerLocale"
                  :disabled-date="disabledDate"
                  :disabled-time="disabledTime"
                  input-read-only
                />
              </a-form-model-item>
              <a-form-model-item :label="$t('i18n_section')" prop="section">
                <a-select
                  v-model="form.section"
                  :placeholder="
                    $t('i18n_rule_required_select', {
                      field: $t('i18n_section')
                    })
                  "
                >
                  <a-select-option
                    v-for="s in sectionList"
                    :key="s.id"
                    :value="s.id"
                  >
                    {{ s.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('i18n_division')" prop="division">
                <a-select
                  v-model="form.division"
                  :placeholder="
                    $t('i18n_rule_required_select', {
                      field: $t('i18n_division')
                    })
                  "
                >
                  <a-select-option
                    v-for="d in divisionList"
                    :key="d.id"
                    :value="d.id"
                  >
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                :label="$t('i18n_channel_name')"
                prop="channel"
              >
                <a-select
                  v-model="form.channel"
                  :placeholder="
                    $t('i18n_rule_required_select', {
                      field: $t('i18n_channel_name')
                    })
                  "
                  show-search
                  :filter-option="filterOption"
                  :disabled="!form.section"
                >
                  <a-select-option
                    v-for="s in channelsUnderSection"
                    :key="s.id"
                    :value="s.id"
                  >
                    {{ s.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                :label="$t('i18n_rec_address')"
                prop="recAddress"
              >
                <a-select
                  v-model="form.recAddress"
                  :placeholder="
                    $t('i18n_rule_required_select', {
                      field: $t('i18n_rec_address')
                    })
                  "
                  :disabled="!form.section"
                  style="width: 500px; margin-right: 10px;"
                >
                  <a-select-option
                    v-for="address in recAddressList"
                    :key="address.id"
                    :value="address.addr"
                  >
                    {{ address.addr }}
                  </a-select-option>
                </a-select>
                <a-button
                  v-clipboard:copy="form.recAddress"
                  v-clipboard:success="onCopy"
                  size="small"
                  type="primary"
                  :disabled="!form.recAddress"
                >
                  {{ $t('i18n_fast_copy') }}
                </a-button>
              </a-form-model-item>
              <a-form-model-item
                :label="$t('i18n_pay_address')"
                prop="payAddress"
              >
                <a-input
                  v-model="form.payAddress"
                  v-custom-trim
                  :placeholder="
                    $t('i18n_rule_required_fill', {
                      field: $t('i18n_pay_address')
                    })
                  "
                />
              </a-form-model-item>
              <!-- 依設定的建單方式決定這邊是input計畫幣數or計畫金額 start -->
              <a-form-model-item
                v-if="currentExchangeType === 1"
                :label="$t('i18n_plan_money')"
                prop="planCoin"
              >
                <a-input-number
                  v-model="form.planCoin"
                  :placeholder="
                    $t('i18n_rule_required_fill', {
                      field: $t('i18n_plan_money')
                    })
                  "
                  :min="0.00000001"
                  :precision="8"
                  :step="0.00000001"
                  :formatter="commaFormater"
                  :parser="numberParser"
                  @change="handleChangePlanCoin"
                />
              </a-form-model-item>
              <a-form-model-item
                v-if="currentExchangeType === 2"
                :label="$t('i18n_plan_amount')"
                prop="planAmount"
              >
                <a-input-number
                  v-model="form.planAmount"
                  :placeholder="
                    $t('i18n_rule_required_fill', {
                      field: $t('i18n_plan_amount')
                    })
                  "
                  :min="0.00000001"
                  :precision="8"
                  :step="0.00000001"
                  :formatter="commaFormater"
                  :parser="numberParser"
                  @change="handleChangePlanCoin"
                />
              </a-form-model-item>
              <!-- 依設定的建單方式決定這邊是input計畫幣數or計畫金額 end -->
              <a-tooltip
                v-show="exchangeRateRemark"
                class="tips"
                placement="top"
                trigger="hover"
                :overlay-style="{ whiteSpace: 'break-spaces' }"
                :title="exchangeRateRemark"
              >
                <a-icon type="question-circle" theme="filled" />
              </a-tooltip>
              <a-form-model-item :label="$t('i18n_rec_exchange_rate')">
                <span>{{ rate }}</span>
              </a-form-model-item>
              <!-- 依設定的建單方式決定這邊是show計畫幣數or計畫金額 start -->
              <a-form-model-item
                v-show="currentExchangeType === 1"
                :label="$t('i18n_plan_amount_ten_thousand')"
              >
                <span>{{ planAmountText }}</span>
              </a-form-model-item>
              <a-form-model-item
                v-show="currentExchangeType === 2"
                :label="$t('i18n_plan_money')"
              >
                <span>{{ planPaidCoinText }}</span>
              </a-form-model-item>
              <!-- 依設定的建單方式決定這邊是show計畫幣數or計畫金額 end -->
              <a-form-model-item :label="$t('i18n_memo')" prop="memo">
                <a-input v-model="form.memo" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="24">
              <div class="button-area">
                <router-link :to="{ name: 'Order.List' }">
                  <a-button class="custom_m--r1">
                    {{ $t('i18n_cancel') }}
                  </a-button>
                </router-link>
                <a-button
                  type="primary"
                  style="margin-left: 10px"
                  @click="handleSubmit"
                >
                  {{ $t('i18n_confirm') }}
                </a-button>
              </div>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-col>
  </div>
</template>

<script>
import { errorModal } from '@GUTIL/prompt'
import InputsProps from '@G/mixins/InputsProps'
import {
  paddingDecimal,
  commaFormat,
  IsoFormat,
  toUnixTimestamp
} from '@GUTIL/format'
import debounce from 'lodash.debounce'
import { datePickerLocale } from '@GUTIL'
import { STATUS } from '@GUTIL/hardCode'

export default {
  mixins: [InputsProps],
  data() {
    return {
      isLoading: false,
      form: {
        createdAt: undefined,
        section: undefined,
        division: undefined,
        recAddress: undefined,
        channel: undefined,
        payAddress: '',
        planCoin: undefined,
        planAmount: undefined,
        memo: ''
      },
      rules: {
        createdAt: [
          {
            required: true,
            message: this.$t('i18n_rule_required_select', {
              field: this.$t('i18n_order_create_time')
            })
          }
        ],
        section: [
          {
            required: true,
            message: this.$t('i18n_rule_required_select', {
              field: this.$t('i18n_section')
            })
          }
        ],
        division: [
          {
            required: true,
            message: this.$t('i18n_rule_required_select', {
              field: this.$t('i18n_division')
            })
          }
        ],
        recAddress: [
          {
            required: true,
            message: this.$t('i18n_rule_required_fill', {
              field: this.$t('i18n_rec_address')
            })
          }
        ],
        channel: [
          {
            required: true,
            message: this.$t('i18n_rule_required_select', {
              field: this.$t('i18n_channel_name')
            })
          }
        ],
        payAddress: [
          {
            required: true,
            message: this.$t('i18n_rule_required_fill', {
              field: this.$t('i18n_pay_address')
            })
          }
        ],
        planCoin: [
          {
            required: true,
            message: this.$t('i18n_rule_required_fill', {
              field: this.$t('i18n_plan_money')
            })
          }
        ],
        planAmount: [
          {
            required: true,
            message: this.$t('i18n_rule_required_fill', {
              field: this.$t('i18n_plan_amount')
            })
          }
        ]
      },
      departmentList: [],
      sectionList: [],
      divisionList: [],
      channelList: [],
      rate: undefined, // 收幣匯率
      exchangeRateRemark: undefined, // 匯率說明文字
      datePickerLocale: datePickerLocale()
    }
  },
  computed: {
    /**
     * 收幣地址
     */
    recAddressList() {
      return this.sectionList.find(item => item.id === this.form.section)
        ? this.sectionList
            .find(item => item.id === this.form.section)
            .addrs.filter(addr => addr.status === 1)
        : []
    },
    /**
     * 項目組下的通道
     */
    channelsUnderSection() {
      return this.sectionList.find(item => item.id === this.form.section)
        ? this.sectionList.find(item => item.id === this.form.section).channels
        : []
    },
    /**
     * 計畫金額
     */
    planAmount() {
      return this.rate * this.form.planCoin
    },
    /**
     * 計畫金額(百)
     */
    planAmountText() {
      if (this.planAmount) {
        return commaFormat(paddingDecimal(this.planAmount / 10000, 6))
      } else {
        return '-'
      }
    },
    /**
     * 計畫幣數
     */
    planPaidCoin() {
      return this.form.planAmount / this.rate
    },
    planPaidCoinText() {
      if (this.planPaidCoin) {
        return commaFormat(paddingDecimal(this.planPaidCoin, 8))
      } else {
        return '-'
      }
    },
    myID() {
      return this.$store.getters.meInfo.id
    },
    /**
     * 當前所選項目組的建單方式
     */
    currentExchangeType() {
      return this.sectionList.find(item => item.id === this.form.section)
        ? this.sectionList.find(item => item.id === this.form.section)
            .exchange_type
        : null
    },
    gqlErrorOption() {
      return {
        isShowErrorModel: false,
        getError: this.handleErrorResponse
      }
    }
  },
  watch: {
    recAddressList() {
      // reset
      this.form.recAddress = undefined
    }
  },
  async created() {
    this.isLoading = true
    // await this.getDepartmentList()
    await this.getExchangeRateRemark()
    await this.getSelections()
    await this.getDivisions()
    this.isLoading = false
  },
  methods: {
    /**
     * 取得匯率說明文字
     */
    async getExchangeRateRemark() {
      try {
        const {
          allSettings
        } = await this.$departmentGraphqlProvider.getSystemInfo()
        this.exchangeRateRemark = allSettings.exchange_rate_remark
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * 取得分口
     */
    async getDepartmentList() {
      try {
        const params = {
          in: {
            customer_service_id: this.myID
          }
        }
        const {
          allDepartments
        } = await this.$departmentGraphqlProvider.getAllDepartments(params)
        this.departmentList = allDepartments.data
      } catch (error) {
        this.departmentList = []
      }
    },
    /**
     * 取得項目組
     */
    async getSelections() {
      const params = {
        in: {
          base_filter: {
            page: 1,
            per_page: -1
          },
          create_order_status: STATUS.ENABLE
        }
      }
      try {
        const {
          allSections
        } = await this.$departmentGraphqlProvider.getAllSections(params)
        this.sectionList = allSections.data.filter(
          x => x.addrs != null && x.addrs.length > 0
        )
      } catch (error) {
        // err
        this.sectionList = []
      }
    },
    /**
     * 取得組別
     */
    async getDivisions() {
      // getAllDivisions
      try {
        const params = {
          filter: {
            base_filter: {
              page: 1,
              per_page: -1
            }
          }
        }
        const {
          allDivisions
        } = await this.$departmentGraphqlProvider.getAllDivisions(params)
        this.divisionList = allDivisions.data
      } catch (error) {
        console.log(error)
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (!this.rate) {
            errorModal({
              title: this.$t('i18n_exchange_rate_invalid')
            })
            return
          }
          this.isLoading = true
          try {
            const paidCoin =
              this.currentExchangeType === 1
                ? this.form.planCoin
                : parseFloat(this.planPaidCoin.toFixed(8))
            const paidAmount =
              this.currentExchangeType === 1
                ? this.planAmount
                : this.form.planAmount
            const params = {
              in: {
                div_group_id: this.form.division,
                dev_group_id: this.form.department,
                section_group_id: this.form.section,
                channel_group_id: this.form.channel,
                address: this.form.payAddress,
                target_address: this.form.recAddress,
                plan_coin: paidCoin,
                plan_amount: paidAmount,
                plan_exchange_rate: this.rate,
                description: this.form.memo,
                created_at: toUnixTimestamp(IsoFormat(this.form.createdAt)),
                exchange_type: this.currentExchangeType
              }
            }
            const {
              createOrder
            } = await this.$departmentGraphqlProvider.createOrder(params, {
              isShowErrorModel: false,
              getError: (err, originalError) => {
                if (err) {
                  const code = err[0].message
                  if (code === '400201') {
                    errorModal({
                      title: this.$t('i18n_error_order_create_future')
                    })
                  } else {
                    originalError()
                  }
                }
              }
            })
            if (createOrder.id) {
              this.$router.push({ name: 'Order.List' })
            }
          } catch (error) {
            if (error.message.indexOf('400202') >= 0) {
              errorModal({
                title: this.$t('i18n_exchange_rate_invalid')
              })
            }
          }
          this.isLoading = false
        } else {
          return false
        }
      })
    },
    handleChangePlanCoin: debounce(async function(val) {
      if (val) {
        this.isLoading = true
        try {
          const {
            getExchange
          } = await this.$departmentGraphqlProvider.getExchange()
          this.rate = getExchange.exchange
        } catch (error) {
          console.log(error)
        }
        this.isLoading = false
      }
    }, 400),
    async getAllChannels() {
      try {
        const {
          allChannel
        } = await this.$departmentGraphqlProvider.getAllChannel({
          in: {
            base_filter: {
              page: 1,
              per_page: -1
            }
          }
        })
        if (allChannel.data && allChannel.data.length) {
          this.channelList = allChannel.data
        }
      } catch (error) {
        this.channelList = []
      }
    },
    /**
     * 通道名搜尋filter
     */
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onCopy() {
      this.$notification.success({
        message: this.$t('i18n_copy_success')
      })
    },
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    /**
     * 禁止未來時間
     */
    disabledTime(current) {
      const isToday = !current || current >= moment().startOf('day')
      const isCurrentHour =
        !current ||
        (isToday && parseInt(current.format('HH')) >= new Date().getHours())
      return {
        disabledHours: () =>
          isToday ? this.range(new Date().getHours() + 1, 24) : [],
        disabledMinutes: () =>
          isCurrentHour ? this.range(new Date().getMinutes() + 1, 60) : [],
        disabledSeconds: () => []
      }
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    handleErrorResponse(errors, showOriginError) {
      // 新增/補訂單的當下有人更改項目組的建單狀態, 有可能會導致使用者選到被disable的項目組
      errors.forEach(err => {
        try {
          let isInvalidSection = false
          const {
            extensions: { err_msg }
          } = err
          // { key1: 404012, ... }  string to object
          const errObj = JSON.parse(err_msg)
          isInvalidSection = errObj['section_group_id'] == '404012'

          if (isInvalidSection) {
            errorModal({
              title: this.$t('i18n_order_section_is_not_avalible')
            })
          } else {
            showOriginError()
          }
        } catch (e) {
          showOriginError()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ant-calendar-picker {
  input {
    width: 100%;
  }
}

/deep/ .tips {
  float: left;
  position: absolute;
  left: 9%;
  margin: 12px 0 0;
  z-index: 10000;
}
</style>
